<template>
  <div class="ma-content" v-if="!loading">
    <v-row v-if="showDiagnosticCard">
      <v-col cols="12" md="12"><DiagnosticCard /></v-col>
    </v-row>
    <v-row v-if="welcomeCard || whereToStartCard">
      <v-col cols="12" :md="whereToStartCard ? 6 : 12" v-if="welcomeCard"><ContentCard :card="welcomeCard" name="WelcomeCard" /></v-col>
      <v-col cols="12" :md="welcomeCard ? 6 : 12" v-if="whereToStartCard"><ContentCard :card="whereToStartCard" name="WhereToStartCard" /></v-col>
    </v-row>
    <v-row v-if="showWhatNextCard">
      <v-col cols="12" md="12"><WhatNextCard /></v-col>
    </v-row>
    <v-row v-if="generalNewsCard || studentNewsCard">
      <v-col cols="12" :md="studentNewsCard ? 6 : 12" v-if="generalNewsCard"><ContentCard :card="generalNewsCard" name="GeneralNewsCard" /></v-col>
      <v-col cols="12" :md="generalNewsCard ? 6 : 12" v-if="studentNewsCard"><ContentCard :card="studentNewsCard" name="StudentNewsCard" /></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :md="hasWordOfTheDayCard ? 6 : 12"><TaskSummaryCard /></v-col>
      <v-col cols="12" md="6" v-if="hasWordOfTheDayCard"><WordOfTheDayCard /></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12"><StrengthsAndWeaknessesCard /></v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import StrengthsAndWeaknessesCard from "./StrengthsAndWeaknessesCard.vue";
import TaskSummaryCard from "./TaskSummaryCard.vue";
import WordOfTheDayCard from "./WordOfTheDayCard.vue";
import ContentCard from "../../resource/card/ContentCard.vue";
import WhatNextCard from "./WhatNextCard.vue";
import DiagnosticCard from "./DiagnosticCard.vue";

export default {
  name: "StudentHome",
  components: {DiagnosticCard, WhatNextCard, WordOfTheDayCard, ContentCard, TaskSummaryCard, StrengthsAndWeaknessesCard},
  computed: {
    ...mapState('dashboard', ['data']),
    ...mapGetters('app', ['hasWordOfTheDayCard']),
    loading() {
      return !this.data;
    },
    showDiagnosticCard() {
      return this.data.diagnostic?.visible;
    },
    showWhatNextCard() {
      return this.data.whatNext?.visible;
    },
    welcomeCard() {
      return this.data.cards.welcome;
    },
    whereToStartCard() {
      return this.data.cards.whereToStart;
    },
    studentNewsCard() {
      return this.data.cards.studentNews
    },
    generalNewsCard() {
      return this.data.cards.musicNews;
    },
  },
  methods: {
    ...mapActions('ui', ['resetBreadcrumbs']),
    ...mapActions('dashboard', ['loadData']),
  },
}
</script>

<style lang="scss">
@import '../style';

$block-title-color: lighten($col-home, 60%);

.ma-home {
  @include withTitleBlock($col-home);
}

</style>